import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
function enumStringToValue$7(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class PagedResponseMetadata {
  static fromProto(proto) {
    let m = new PagedResponseMetadata();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
function enumStringToValue$6(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CommonResource {
  static fromProto(proto) {
    let m = new CommonResource();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
}
function enumStringToValue$5(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ExtractedValue {
  static fromProto(proto) {
    let m = new ExtractedValue();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.valuePath !== 'undefined') {
      toReturn['valuePath'] = this.valuePath;
    }
    return toReturn;
  }
}
class Filter {
  static fromProto(proto) {
    let m = new Filter();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = ExtractedValue.fromProto(proto.value);
    }
    if (proto.options) {
      m.options = proto.options.map(FilterOption.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    if (typeof this.label !== 'undefined') {
      toReturn['label'] = this.label;
    }
    if (typeof this.options !== 'undefined' && this.options !== null) {
      toReturn['options'] = 'toApiJson' in this.options ? this.options.toApiJson() : this.options;
    }
    return toReturn;
  }
}
class FilterOption {
  static fromProto(proto) {
    let m = new FilterOption();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class Icon {
  static fromProto(proto) {
    let m = new Icon();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.iconPath !== 'undefined') {
      toReturn['iconPath'] = this.iconPath;
    }
    if (typeof this.matIcon !== 'undefined') {
      toReturn['matIcon'] = this.matIcon;
    }
    return toReturn;
  }
}
class IconResource {
  static fromProto(proto) {
    let m = new IconResource();
    m = Object.assign(m, proto);
    if (proto.defaultIcon) {
      m.defaultIcon = Icon.fromProto(proto.defaultIcon);
    }
    if (proto.customTypes) {
      m.customTypes = proto.customTypes.map(IconType.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.resourcePath !== 'undefined') {
      toReturn['resourcePath'] = this.resourcePath;
    }
    if (typeof this.defaultIcon !== 'undefined' && this.defaultIcon !== null) {
      toReturn['defaultIcon'] = 'toApiJson' in this.defaultIcon ? this.defaultIcon.toApiJson() : this.defaultIcon;
    }
    if (typeof this.customTypes !== 'undefined' && this.customTypes !== null) {
      toReturn['customTypes'] = 'toApiJson' in this.customTypes ? this.customTypes.toApiJson() : this.customTypes;
    }
    return toReturn;
  }
}
class IconType {
  static fromProto(proto) {
    let m = new IconType();
    m = Object.assign(m, proto);
    if (proto.icon) {
      m.icon = Icon.fromProto(proto.icon);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.icon !== 'undefined' && this.icon !== null) {
      toReturn['icon'] = 'toApiJson' in this.icon ? this.icon.toApiJson() : this.icon;
    }
    return toReturn;
  }
}
class PostType {
  static fromProto(proto) {
    let m = new PostType();
    m = Object.assign(m, proto);
    if (proto.commonResources) {
      m.commonResources = proto.commonResources.map(ExtractedValue.fromProto);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.filters) {
      m.filters = proto.filters.map(Filter.fromProto);
    }
    if (proto.iconResource) {
      m.iconResource = IconResource.fromProto(proto.iconResource);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.typeId !== 'undefined') {
      toReturn['typeId'] = this.typeId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.postIdTemplate !== 'undefined') {
      toReturn['postIdTemplate'] = this.postIdTemplate;
    }
    if (typeof this.eventTypeId !== 'undefined') {
      toReturn['eventTypeId'] = this.eventTypeId;
    }
    if (typeof this.commonResources !== 'undefined' && this.commonResources !== null) {
      toReturn['commonResources'] = 'toApiJson' in this.commonResources ? this.commonResources.toApiJson() : this.commonResources;
    }
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.partnerIdPath !== 'undefined') {
      toReturn['partnerIdPath'] = this.partnerIdPath;
    }
    if (typeof this.marketIdPath !== 'undefined') {
      toReturn['marketIdPath'] = this.marketIdPath;
    }
    if (typeof this.userIdPath !== 'undefined') {
      toReturn['userIdPath'] = this.userIdPath;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.channel !== 'undefined') {
      toReturn['channel'] = this.channel;
    }
    if (typeof this.iconResource !== 'undefined' && this.iconResource !== null) {
      toReturn['iconResource'] = 'toApiJson' in this.iconResource ? this.iconResource.toApiJson() : this.iconResource;
    }
    return toReturn;
  }
}
function enumStringToValue$4(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class User {
  static fromProto(proto) {
    let m = new User();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    return toReturn;
  }
}
function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Comment {
  static fromProto(proto) {
    let m = new Comment();
    m = Object.assign(m, proto);
    if (proto.user) {
      m.user = User.fromProto(proto.user);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.user !== 'undefined' && this.user !== null) {
      toReturn['user'] = 'toApiJson' in this.user ? this.user.toApiJson() : this.user;
    }
    if (typeof this.text !== 'undefined') {
      toReturn['text'] = this.text;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    return toReturn;
  }
}
function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class PostLatestComments {
  static fromProto(proto) {
    let m = new PostLatestComments();
    m = Object.assign(m, proto);
    if (proto.comments) {
      m.comments = proto.comments.map(Comment.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.comments !== 'undefined' && this.comments !== null) {
      toReturn['comments'] = 'toApiJson' in this.comments ? this.comments.toApiJson() : this.comments;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class Post {
  static fromProto(proto) {
    let m = new Post();
    m = Object.assign(m, proto);
    if (proto.postIdentifier) {
      m.postIdentifier = PostIdentifier.fromProto(proto.postIdentifier);
    }
    if (proto.user) {
      m.user = User.fromProto(proto.user);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.likes) {
      m.likes = proto.likes.map(User.fromProto);
    }
    if (proto.latestComments) {
      m.latestComments = PostLatestComments.fromProto(proto.latestComments);
    }
    if (proto.icon) {
      m.icon = Icon.fromProto(proto.icon);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.postIdentifier !== 'undefined' && this.postIdentifier !== null) {
      toReturn['postIdentifier'] = 'toApiJson' in this.postIdentifier ? this.postIdentifier.toApiJson() : this.postIdentifier;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.user !== 'undefined' && this.user !== null) {
      toReturn['user'] = 'toApiJson' in this.user ? this.user.toApiJson() : this.user;
    }
    if (typeof this.resources !== 'undefined') {
      toReturn['resources'] = this.resources;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.html !== 'undefined') {
      toReturn['html'] = this.html;
    }
    if (typeof this.likes !== 'undefined' && this.likes !== null) {
      toReturn['likes'] = 'toApiJson' in this.likes ? this.likes.toApiJson() : this.likes;
    }
    if (typeof this.latestComments !== 'undefined' && this.latestComments !== null) {
      toReturn['latestComments'] = 'toApiJson' in this.latestComments ? this.latestComments.toApiJson() : this.latestComments;
    }
    if (typeof this.isSubscribed !== 'undefined') {
      toReturn['isSubscribed'] = this.isSubscribed;
    }
    if (typeof this.style !== 'undefined') {
      toReturn['style'] = this.style;
    }
    if (typeof this.icon !== 'undefined' && this.icon !== null) {
      toReturn['icon'] = 'toApiJson' in this.icon ? this.icon.toApiJson() : this.icon;
    }
    return toReturn;
  }
}
class PostIdentifier {
  static fromProto(proto) {
    let m = new PostIdentifier();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.postId !== 'undefined') {
      toReturn['postId'] = this.postId;
    }
    if (typeof this.typeId !== 'undefined') {
      toReturn['typeId'] = this.typeId;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Access {
  static fromProto(proto) {
    let m = new Access();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    if (typeof this.public !== 'undefined') {
      toReturn['public'] = this.public;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var RenderOption = /*#__PURE__*/function (RenderOption) {
  RenderOption[RenderOption["RENDER_OPTION_FULL"] = 0] = "RENDER_OPTION_FULL";
  RenderOption[RenderOption["RENDER_OPTION_COMPACT"] = 1] = "RENDER_OPTION_COMPACT";
  return RenderOption;
}(RenderOption || {});
// *********************************

function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CommentRequest {
  static fromProto(proto) {
    let m = new CommentRequest();
    m = Object.assign(m, proto);
    if (proto.postIdentifier) {
      m.postIdentifier = PostIdentifier.fromProto(proto.postIdentifier);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.postIdentifier !== 'undefined' && this.postIdentifier !== null) {
      toReturn['postIdentifier'] = 'toApiJson' in this.postIdentifier ? this.postIdentifier.toApiJson() : this.postIdentifier;
    }
    if (typeof this.text !== 'undefined') {
      toReturn['text'] = this.text;
    }
    return toReturn;
  }
}
class CommentResponse {
  static fromProto(proto) {
    let m = new CommentResponse();
    m = Object.assign(m, proto);
    if (proto.comment) {
      m.comment = Comment.fromProto(proto.comment);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.comment !== 'undefined' && this.comment !== null) {
      toReturn['comment'] = 'toApiJson' in this.comment ? this.comment.toApiJson() : this.comment;
    }
    return toReturn;
  }
}
class UpdatePostTypeRequestOperationCommonResources {
  static fromProto(proto) {
    let m = new UpdatePostTypeRequestOperationCommonResources();
    m = Object.assign(m, proto);
    if (proto.commonResources) {
      m.commonResources = proto.commonResources.map(ExtractedValue.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.commonResources !== 'undefined' && this.commonResources !== null) {
      toReturn['commonResources'] = 'toApiJson' in this.commonResources ? this.commonResources.toApiJson() : this.commonResources;
    }
    return toReturn;
  }
}
class CreateCommonResourceRequest {
  static fromProto(proto) {
    let m = new CreateCommonResourceRequest();
    m = Object.assign(m, proto);
    if (proto.commonResource) {
      m.commonResource = CommonResource.fromProto(proto.commonResource);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.commonResource !== 'undefined' && this.commonResource !== null) {
      toReturn['commonResource'] = 'toApiJson' in this.commonResource ? this.commonResource.toApiJson() : this.commonResource;
    }
    return toReturn;
  }
}
class CreatePostTypeRequest {
  static fromProto(proto) {
    let m = new CreatePostTypeRequest();
    m = Object.assign(m, proto);
    if (proto.postType) {
      m.postType = PostType.fromProto(proto.postType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.postType !== 'undefined' && this.postType !== null) {
      toReturn['postType'] = 'toApiJson' in this.postType ? this.postType.toApiJson() : this.postType;
    }
    return toReturn;
  }
}
class CreatePostTypeResponse {
  static fromProto(proto) {
    let m = new CreatePostTypeResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.typeId !== 'undefined') {
      toReturn['typeId'] = this.typeId;
    }
    return toReturn;
  }
}
class ListPostsRequestDateRangeFilter {
  static fromProto(proto) {
    let m = new ListPostsRequestDateRangeFilter();
    m = Object.assign(m, proto);
    if (proto.beginRange) {
      m.beginRange = new Date(proto.beginRange);
    }
    if (proto.endRange) {
      m.endRange = new Date(proto.endRange);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.beginRange !== 'undefined' && this.beginRange !== null) {
      toReturn['beginRange'] = 'toApiJson' in this.beginRange ? this.beginRange.toApiJson() : this.beginRange;
    }
    if (typeof this.endRange !== 'undefined' && this.endRange !== null) {
      toReturn['endRange'] = 'toApiJson' in this.endRange ? this.endRange.toApiJson() : this.endRange;
    }
    return toReturn;
  }
}
class DeletePostTypeRequest {
  static fromProto(proto) {
    let m = new DeletePostTypeRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.typeId !== 'undefined') {
      toReturn['typeId'] = this.typeId;
    }
    return toReturn;
  }
}
class UpdatePostTypeRequestOperationFilters {
  static fromProto(proto) {
    let m = new UpdatePostTypeRequestOperationFilters();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = proto.filters.map(Filter.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    return toReturn;
  }
}
class ListPostTypesRequestFilters {
  static fromProto(proto) {
    let m = new ListPostTypesRequestFilters();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.channel !== 'undefined') {
      toReturn['channel'] = this.channel;
    }
    return toReturn;
  }
}
class GetChannelsRequest {
  static fromProto(proto) {
    let m = new GetChannelsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class GetChannelsResponse {
  static fromProto(proto) {
    let m = new GetChannelsResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.channels !== 'undefined') {
      toReturn['channels'] = this.channels;
    }
    return toReturn;
  }
}
class GetPostRequest {
  static fromProto(proto) {
    let m = new GetPostRequest();
    m = Object.assign(m, proto);
    if (proto.postIdentifier) {
      m.postIdentifier = PostIdentifier.fromProto(proto.postIdentifier);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.postIdentifier !== 'undefined' && this.postIdentifier !== null) {
      toReturn['postIdentifier'] = 'toApiJson' in this.postIdentifier ? this.postIdentifier.toApiJson() : this.postIdentifier;
    }
    return toReturn;
  }
}
class GetPostResponse {
  static fromProto(proto) {
    let m = new GetPostResponse();
    m = Object.assign(m, proto);
    if (proto.post) {
      m.post = Post.fromProto(proto.post);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.post !== 'undefined' && this.post !== null) {
      toReturn['post'] = 'toApiJson' in this.post ? this.post.toApiJson() : this.post;
    }
    return toReturn;
  }
}
class GetPostTypeRequest {
  static fromProto(proto) {
    let m = new GetPostTypeRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.typeId !== 'undefined') {
      toReturn['typeId'] = this.typeId;
    }
    return toReturn;
  }
}
class GetPostTypeResponse {
  static fromProto(proto) {
    let m = new GetPostTypeResponse();
    m = Object.assign(m, proto);
    if (proto.postType) {
      m.postType = PostType.fromProto(proto.postType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.postType !== 'undefined' && this.postType !== null) {
      toReturn['postType'] = 'toApiJson' in this.postType ? this.postType.toApiJson() : this.postType;
    }
    return toReturn;
  }
}
class LikeRequest {
  static fromProto(proto) {
    let m = new LikeRequest();
    m = Object.assign(m, proto);
    if (proto.postIdentifier) {
      m.postIdentifier = PostIdentifier.fromProto(proto.postIdentifier);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.postIdentifier !== 'undefined' && this.postIdentifier !== null) {
      toReturn['postIdentifier'] = 'toApiJson' in this.postIdentifier ? this.postIdentifier.toApiJson() : this.postIdentifier;
    }
    return toReturn;
  }
}
class LikeResponse {
  static fromProto(proto) {
    let m = new LikeResponse();
    m = Object.assign(m, proto);
    if (proto.user) {
      m.user = User.fromProto(proto.user);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.user !== 'undefined' && this.user !== null) {
      toReturn['user'] = 'toApiJson' in this.user ? this.user.toApiJson() : this.user;
    }
    return toReturn;
  }
}
class ListCommentsRequest {
  static fromProto(proto) {
    let m = new ListCommentsRequest();
    m = Object.assign(m, proto);
    if (proto.postIdentifier) {
      m.postIdentifier = PostIdentifier.fromProto(proto.postIdentifier);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.postIdentifier !== 'undefined' && this.postIdentifier !== null) {
      toReturn['postIdentifier'] = 'toApiJson' in this.postIdentifier ? this.postIdentifier.toApiJson() : this.postIdentifier;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListCommentsResponse {
  static fromProto(proto) {
    let m = new ListCommentsResponse();
    m = Object.assign(m, proto);
    if (proto.comments) {
      m.comments = proto.comments.map(Comment.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.comments !== 'undefined' && this.comments !== null) {
      toReturn['comments'] = 'toApiJson' in this.comments ? this.comments.toApiJson() : this.comments;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListCommonResourcesRequest {
  static fromProto(proto) {
    let m = new ListCommonResourcesRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListCommonResourcesResponse {
  static fromProto(proto) {
    let m = new ListCommonResourcesResponse();
    m = Object.assign(m, proto);
    if (proto.commonResources) {
      m.commonResources = proto.commonResources.map(CommonResource.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.commonResources !== 'undefined' && this.commonResources !== null) {
      toReturn['commonResources'] = 'toApiJson' in this.commonResources ? this.commonResources.toApiJson() : this.commonResources;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListPostTypesRequest {
  static fromProto(proto) {
    let m = new ListPostTypesRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListPostTypesRequestFilters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListPostTypesResponse {
  static fromProto(proto) {
    let m = new ListPostTypesResponse();
    m = Object.assign(m, proto);
    if (proto.postTypes) {
      m.postTypes = proto.postTypes.map(PostType.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.postTypes !== 'undefined' && this.postTypes !== null) {
      toReturn['postTypes'] = 'toApiJson' in this.postTypes ? this.postTypes.toApiJson() : this.postTypes;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListPostsRequest {
  static fromProto(proto) {
    let m = new ListPostsRequest();
    m = Object.assign(m, proto);
    if (proto.dateRange) {
      m.dateRange = ListPostsRequestDateRangeFilter.fromProto(proto.dateRange);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    if (proto.renderOption) {
      m.renderOption = enumStringToValue(RenderOption, proto.renderOption);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketIds !== 'undefined') {
      toReturn['marketIds'] = this.marketIds;
    }
    if (typeof this.userIds !== 'undefined') {
      toReturn['userIds'] = this.userIds;
    }
    if (typeof this.postTypeIds !== 'undefined') {
      toReturn['postTypeIds'] = this.postTypeIds;
    }
    if (typeof this.resourceFilters !== 'undefined') {
      toReturn['resourceFilters'] = this.resourceFilters;
    }
    if (typeof this.dateRange !== 'undefined' && this.dateRange !== null) {
      toReturn['dateRange'] = 'toApiJson' in this.dateRange ? this.dateRange.toApiJson() : this.dateRange;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.renderOption !== 'undefined') {
      toReturn['renderOption'] = this.renderOption;
    }
    return toReturn;
  }
}
class ListPostsResponse {
  static fromProto(proto) {
    let m = new ListPostsResponse();
    m = Object.assign(m, proto);
    if (proto.posts) {
      m.posts = proto.posts.map(Post.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.posts !== 'undefined' && this.posts !== null) {
      toReturn['posts'] = 'toApiJson' in this.posts ? this.posts.toApiJson() : this.posts;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
class UpdatePostTypeRequestOperation {
  static fromProto(proto) {
    let m = new UpdatePostTypeRequestOperation();
    m = Object.assign(m, proto);
    if (proto.commonResources) {
      m.commonResources = UpdatePostTypeRequestOperationCommonResources.fromProto(proto.commonResources);
    }
    if (proto.filters) {
      m.filters = UpdatePostTypeRequestOperationFilters.fromProto(proto.filters);
    }
    if (proto.iconResource) {
      m.iconResource = IconResource.fromProto(proto.iconResource);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.commonResources !== 'undefined' && this.commonResources !== null) {
      toReturn['commonResources'] = 'toApiJson' in this.commonResources ? this.commonResources.toApiJson() : this.commonResources;
    }
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    if (typeof this.partnerIdPath !== 'undefined') {
      toReturn['partnerIdPath'] = this.partnerIdPath;
    }
    if (typeof this.marketIdPath !== 'undefined') {
      toReturn['marketIdPath'] = this.marketIdPath;
    }
    if (typeof this.userIdPath !== 'undefined') {
      toReturn['userIdPath'] = this.userIdPath;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.channel !== 'undefined') {
      toReturn['channel'] = this.channel;
    }
    if (typeof this.iconResource !== 'undefined' && this.iconResource !== null) {
      toReturn['iconResource'] = 'toApiJson' in this.iconResource ? this.iconResource.toApiJson() : this.iconResource;
    }
    if (typeof this.postIdTemplate !== 'undefined') {
      toReturn['postIdTemplate'] = this.postIdTemplate;
    }
    return toReturn;
  }
}
class PagedRequestOptions {
  static fromProto(proto) {
    let m = new PagedRequestOptions();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class SubscribeRequest {
  static fromProto(proto) {
    let m = new SubscribeRequest();
    m = Object.assign(m, proto);
    if (proto.postIdentifier) {
      m.postIdentifier = PostIdentifier.fromProto(proto.postIdentifier);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.postIdentifier !== 'undefined' && this.postIdentifier !== null) {
      toReturn['postIdentifier'] = 'toApiJson' in this.postIdentifier ? this.postIdentifier.toApiJson() : this.postIdentifier;
    }
    return toReturn;
  }
}
class UnlikeRequest {
  static fromProto(proto) {
    let m = new UnlikeRequest();
    m = Object.assign(m, proto);
    if (proto.postIdentifier) {
      m.postIdentifier = PostIdentifier.fromProto(proto.postIdentifier);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.postIdentifier !== 'undefined' && this.postIdentifier !== null) {
      toReturn['postIdentifier'] = 'toApiJson' in this.postIdentifier ? this.postIdentifier.toApiJson() : this.postIdentifier;
    }
    return toReturn;
  }
}
class UnsubscribeRequest {
  static fromProto(proto) {
    let m = new UnsubscribeRequest();
    m = Object.assign(m, proto);
    if (proto.postIdentifier) {
      m.postIdentifier = PostIdentifier.fromProto(proto.postIdentifier);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.postIdentifier !== 'undefined' && this.postIdentifier !== null) {
      toReturn['postIdentifier'] = 'toApiJson' in this.postIdentifier ? this.postIdentifier.toApiJson() : this.postIdentifier;
    }
    return toReturn;
  }
}
class UpdatePostTypeRequest {
  static fromProto(proto) {
    let m = new UpdatePostTypeRequest();
    m = Object.assign(m, proto);
    if (proto.operations) {
      m.operations = proto.operations.map(UpdatePostTypeRequestOperation.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.typeId !== 'undefined') {
      toReturn['typeId'] = this.typeId;
    }
    if (typeof this.operations !== 'undefined' && this.operations !== null) {
      toReturn['operations'] = 'toApiJson' in this.operations ? this.operations.toApiJson() : this.operations;
    }
    return toReturn;
  }
}

// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'the-loop-api.vendasta-local.com',
  'test': '',
  'demo': 'the-loop-demo.apigateway.co',
  'prod': 'the-loop-prod.apigateway.co',
  'production': 'the-loop-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let TheLoopApiService = /*#__PURE__*/(() => {
  class TheLoopApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getPost(r) {
      const request = r.toApiJson ? r : new GetPostRequest(r);
      return this.http.post(this._host + "/theloop.v1.TheLoop/GetPost", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetPostResponse.fromProto(resp)));
    }
    listPosts(r) {
      const request = r.toApiJson ? r : new ListPostsRequest(r);
      return this.http.post(this._host + "/theloop.v1.TheLoop/ListPosts", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListPostsResponse.fromProto(resp)));
    }
    getPostType(r) {
      const request = r.toApiJson ? r : new GetPostTypeRequest(r);
      return this.http.post(this._host + "/theloop.v1.TheLoop/GetPostType", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetPostTypeResponse.fromProto(resp)));
    }
    createPostType(r) {
      const request = r.toApiJson ? r : new CreatePostTypeRequest(r);
      return this.http.post(this._host + "/theloop.v1.TheLoop/CreatePostType", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreatePostTypeResponse.fromProto(resp)));
    }
    updatePostType(r) {
      const request = r.toApiJson ? r : new UpdatePostTypeRequest(r);
      return this.http.post(this._host + "/theloop.v1.TheLoop/UpdatePostType", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deletePostType(r) {
      const request = r.toApiJson ? r : new DeletePostTypeRequest(r);
      return this.http.post(this._host + "/theloop.v1.TheLoop/DeletePostType", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getChannels(r) {
      const request = r.toApiJson ? r : new GetChannelsRequest(r);
      return this.http.post(this._host + "/theloop.v1.TheLoop/GetChannels", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetChannelsResponse.fromProto(resp)));
    }
    listPostTypes(r) {
      const request = r.toApiJson ? r : new ListPostTypesRequest(r);
      return this.http.post(this._host + "/theloop.v1.TheLoop/ListPostTypes", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListPostTypesResponse.fromProto(resp)));
    }
    createCommonResource(r) {
      const request = r.toApiJson ? r : new CreateCommonResourceRequest(r);
      return this.http.post(this._host + "/theloop.v1.TheLoop/CreateCommonResource", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listCommonResources(r) {
      const request = r.toApiJson ? r : new ListCommonResourcesRequest(r);
      return this.http.post(this._host + "/theloop.v1.TheLoop/ListCommonResources", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListCommonResourcesResponse.fromProto(resp)));
    }
    comment(r) {
      const request = r.toApiJson ? r : new CommentRequest(r);
      return this.http.post(this._host + "/theloop.v1.TheLoop/Comment", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommentResponse.fromProto(resp)));
    }
    listComments(r) {
      const request = r.toApiJson ? r : new ListCommentsRequest(r);
      return this.http.post(this._host + "/theloop.v1.TheLoop/ListComments", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListCommentsResponse.fromProto(resp)));
    }
    like(r) {
      const request = r.toApiJson ? r : new LikeRequest(r);
      return this.http.post(this._host + "/theloop.v1.TheLoop/Like", request.toApiJson(), this.apiOptions()).pipe(map(resp => LikeResponse.fromProto(resp)));
    }
    unlike(r) {
      const request = r.toApiJson ? r : new UnlikeRequest(r);
      return this.http.post(this._host + "/theloop.v1.TheLoop/Unlike", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    subscribe(r) {
      const request = r.toApiJson ? r : new SubscribeRequest(r);
      return this.http.post(this._host + "/theloop.v1.TheLoop/Subscribe", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    unsubscribe(r) {
      const request = r.toApiJson ? r : new UnsubscribeRequest(r);
      return this.http.post(this._host + "/theloop.v1.TheLoop/Unsubscribe", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  TheLoopApiService.ɵfac = function TheLoopApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TheLoopApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  TheLoopApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: TheLoopApiService,
    factory: TheLoopApiService.ɵfac,
    providedIn: 'root'
  });
  return TheLoopApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function fillPostZeroValues(p) {
  p.likes = !!p.likes ? p.likes : [];
  p.latestComments = !!p.latestComments ? p.latestComments : new PostLatestComments({});
  p.latestComments.comments = !!p.latestComments.comments ? p.latestComments.comments : [];
  p.latestComments.pagingMetadata = !!p.latestComments.pagingMetadata ? p.latestComments.pagingMetadata : new PagedResponseMetadata({});
  return p;
}
class PagedResponse {
  constructor(results, nextCursor, hasMore) {
    this.results = results;
    this.nextCursor = nextCursor;
    this.hasMore = hasMore;
  }
}
let TheLoopService = /*#__PURE__*/(() => {
  class TheLoopService {
    constructor(api) {
      this.api = api;
    }
    getPost(typeId, postId) {
      return this.api.getPost({
        postIdentifier: {
          postId: postId,
          typeId: typeId
        }
      }).pipe(map(resp => fillPostZeroValues(resp.post)));
    }
    getPostType(typeId) {
      return this.api.getPostType({
        typeId: typeId
      }).pipe(map(resp => resp.postType));
    }
    createPostType(postType) {
      return this.api.createPostType({
        postType: postType
      }).pipe(map(resp => resp.typeId));
    }
    updatePostType(typeId, operations) {
      return this.api.updatePostType({
        typeId: typeId,
        operations: operations
      }).pipe(map(() => true));
    }
    deletePostType(typeId) {
      return this.api.deletePostType({
        typeId: typeId
      }).pipe(map(() => true));
    }
    createCommonResource(id, name) {
      return this.api.createCommonResource({
        commonResource: {
          id: id,
          name: name
        }
      }).pipe(map(() => true));
    }
    listCommonResources(pagingOptions) {
      return this.api.listCommonResources({
        pagingOptions: pagingOptions
      }).pipe(map(resp => new PagedResponse(resp.commonResources, resp.pagingMetadata.nextCursor, resp.pagingMetadata.hasMore)));
    }
    comment(typeId, postId, text) {
      return this.api.comment({
        postIdentifier: {
          typeId: typeId,
          postId: postId
        },
        text: text
      }).pipe(map(resp => resp.comment));
    }
    like(typeId, postId) {
      return this.api.like({
        postIdentifier: {
          typeId: typeId,
          postId: postId
        }
      }).pipe(map(resp => resp.user));
    }
    unlike(typeId, postId) {
      return this.api.unlike({
        postIdentifier: {
          typeId: typeId,
          postId: postId
        }
      }).pipe(map(() => true));
    }
    listPosts(fitlers) {
      return this.api.listPosts(fitlers).pipe(map(resp => {
        if (!!resp && resp.posts) {
          resp.posts = resp.posts.map(p => fillPostZeroValues(p));
        }
        return resp;
      }));
    }
    listComments(typeId, postId, cursor, pageSize) {
      return this.api.listComments({
        postIdentifier: {
          typeId: typeId,
          postId: postId
        },
        pagingOptions: {
          cursor: cursor,
          pageSize: pageSize
        }
      }).pipe(map(resp => resp));
    }
    subscribe(typeId, postId) {
      return this.api.subscribe({
        postIdentifier: {
          typeId: typeId,
          postId: postId
        }
      }).pipe(map(() => true));
    }
    unsubscribe(typeId, postId) {
      return this.api.unsubscribe({
        postIdentifier: {
          typeId: typeId,
          postId: postId
        }
      }).pipe(map(() => true));
    }
    getChannels() {
      return this.api.getChannels({}).pipe(map(resp => resp.channels));
    }
    listPostTypes(filters, cursor, pageSize) {
      return this.api.listPostTypes({
        filters: filters,
        pagingOptions: {
          cursor: cursor,
          pageSize: pageSize
        }
      }).pipe(map(resp => {
        return new PagedResponse(resp.postTypes, resp.pagingMetadata.nextCursor, resp.pagingMetadata.hasMore);
      }));
    }
  }
  TheLoopService.ɵfac = function TheLoopService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TheLoopService)(i0.ɵɵinject(TheLoopApiService));
  };
  TheLoopService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: TheLoopService,
    factory: TheLoopService.ɵfac,
    providedIn: 'root'
  });
  return TheLoopService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { Comment, CommonResource, ExtractedValue, Filter, FilterOption, Post, PostIdentifier, PostType, RenderOption, TheLoopService, UpdatePostTypeRequestOperation, User };
